<template>
  <div>
    <p class="has-text-weight-bold is-size-4 mb-2">
      {{ $t("af:preliminary.first_step.title") }}
    </p>

    <p class="has-text-grey-icon">
      {{ $t("af:preliminary.first_step.subtitle") }}
    </p>

    <p class="label mt-5 mb-6">
      {{ $t("af:preliminary.first_step.amount.title") }}
    </p>

    <validation-observer ref="observer">
      <BInputWithValidation
        id="prelimAmountInput"
        :label="$t('af:preliminary.first_step.input.amount.label')"
        :mask="FIELD_MASK.HUF"
        :rules="{ required: true, regex: /^[0-9 ]*$/ }"
        label-position="on-border"
        :value="amount"
        :show-success="false"
        ref="amountInput"
        @blur="adjustAmount"
      >
        <div class="loan-min-max has-text-grey-icon is-size-7">
          <span> Min. {{ filterSettings.amountMin | monify }} HUF</span>
          <span> Max. {{ filterSettings.amountMax | monify }} HUF</span>
        </div>
      </BInputWithValidation>

      <TermSlider class="mt-5" v-model="duration" />
    </validation-observer>

    <div class="offer-change-info mt-4">
      <b-icon
        icon-pack="fa"
        icon="info-circle"
        size="is-medium"
        type="is-blue"
        class="mr-2"
      ></b-icon>
      <span class="has-text-grey-icon">{{
        $t("af:preliminary.first_step.footer")
      }}</span>
    </div>

    <div v-if="activePurchase" class="mb-5">
      <p class="has-text-weight-bold is-size-5 mb-2 mt-6">
        {{ $t("af:preliminary.first_step.purchase.title") }}
      </p>

      <div class="is-flex mt-4">
        <span class="has-text-grey-icon">
          {{ $t("af:preliminary.first_step.purchase.total_amount.label") }}
        </span>

        <span class="has-text-weight-bold ml-auto">
          {{ activePurchase.totalAmount | monify }} Ft
        </span>
      </div>

      <div class="is-flex mt-2">
        <span class="has-text-grey-icon">
          {{ $t("af:preliminary.first_step.purchase.down_payment.label") }}
        </span>

        <span class="has-text-weight-bold ml-auto">
          {{ downPayment | monify }} Ft
        </span>
      </div>

      <div class="is-flex mt-2">
        <span class="has-text-grey-icon">
          {{ $t("af:preliminary.first_step.purchase.extra_amount.label") }}
        </span>

        <span class="has-text-weight-bold ml-auto">
          {{ extraAmount | monify }} Ft
        </span>
      </div>
    </div>
  </div>
</template>

<script>
import { FIELD_MASK } from "../../utils/const";
import merchandiseMixin from "../../mixins/merchandiseMixin";

export default {
  name: "PreliminaryAmountAndTerm",
  mixins: [merchandiseMixin],
  components: {
    BInputWithValidation: () => import("@/components/BInputWithValidation.vue"),
    TermSlider: () => import("@/components/TermSlider.vue"),
  },
  props: {
    filterSettings: {
      type: Object,
      required: true,
    },
    activePurchase: {
      type: Object,
      required: false,
    },
  },
  data() {
    return {
      amount: 0,
      duration: 0,
      downPayment: 0,
      extraAmount: 0,
      FIELD_MASK,
    };
  },
  async created() {
    await this.prefillValue("amount");
    await this.prefillValue("duration");

    if (this.activePurchase) {
      await this.prefillValue("downPayment");
      await this.prefillValue("extraAmount");
    }

    this.$watch("amount", this.amountWatcher);
    this.$watch("duration", this.durationWatcher);
  },
  methods: {
    prefillValue(questionId) {
      this[questionId] = this.getAmountFromStore(questionId);
    },
    getAmountFromStore(questionId) {
      return this.$store.getters["preliminaryAssessment/answer"](questionId);
    },
    storeData(questionId) {
      this.$store.dispatch("preliminaryAssessment/addData", {
        question: questionId,
        answer: this[questionId],
      });
    },
    amountWatcher() {
      this.storeData("amount");

      if (this.activePurchase) {
        this.downPayment = this.calculateDownPayment(this.amount);
        this.extraAmount = this.calculateExtraAmount(this.amount);
        this.storeData("downPayment");
        this.storeData("extraAmount");
      }
    },
    durationWatcher() {
      this.storeData("duration");
    },
    adjustAmount(amountInput) {
      amountInput = Number(amountInput);

      if (!isNaN(amountInput)) {
        let adjustedAmount = amountInput;

        if (amountInput % this.filterSettings.amountStep !== 0) {
          adjustedAmount =
            Math.round(amountInput / this.filterSettings.amountStep) *
            this.filterSettings.amountStep;
        }

        if (adjustedAmount < this.filterSettings.amountMin) {
          adjustedAmount = this.filterSettings.amountMin;
        } else if (adjustedAmount > this.filterSettings.amountMax) {
          adjustedAmount = this.filterSettings.amountMax;
        }

        this.amount = adjustedAmount;
        this.$refs.amountInput.forceUpdate(adjustedAmount);
      }
    },
  },
};
</script>

<style scoped lang="scss">
.offer-change-info {
  display: flex;
  align-items: center;
}

.loan-min-max {
  display: flex;
  width: 100%;
  justify-content: space-between;
}
</style>
